import moment from 'moment'
import { get } from 'lodash'

function formatOldData({ arg }: any) {
  const { hasPdf, data } = arg
  const { payer, payertaxno, invdate } = data
  return {
    buyer: {
      label: '购买方',
      value: {
        payer,
        payertaxno,
        invdate
      }
    },
    taxIdNum: {
      label: '纳税人识别号',
      value: {
        payer,
        payertaxno,
        invdate
      }
    },
    id: data?.id,
    invamt: data.invsumamt,
    invtaxamt: data.invtaxamt,
    type: data.invtype,
    fpdm: data.invcode,
    fphm: data.invno,
    masterItems: [
      {
        label: '销售方名称',
        value: data.payee
      },
      {
        label: '发票代码',
        value: data.invcode
      },
      {
        label: '发票号码',
        value: data.invno
      },
      {
        type: 'date',
        label: '开票日期',
        value: data.invdate
      },
      {
        type: 'money',
        label: '价税合计',
        value: data.invsumamt
      },
      {
        type: 'money',
        label: '税额',
        value: data.invtaxamt
      }
    ],
    source: hasPdf ? 'UPLOAD' : '',
    detailItems: typeof data.itemdata === 'object' ? data.itemdata : JSON.parse(data.itemdata),
    remark: data.remark
  }
}

/**
 * 火车发票
 * @param {data}
 */
function formatInvoiceTrain({ data }:any) {
  const { master } = data
  const { entityId, form, id, status } = master
  return {
    from: {
      id,
      code: form[`E_${entityId}_号码`],
      number: form[`E_${entityId}_车次`],
      money: form[`E_${entityId}_金额`],
      seat: form[`E_${entityId}_座位类型`],
      kind: form[`E_${entityId}_消费类型`],
      timer: form[`E_${entityId}_乘车日期`],
      getOn: form[`E_${entityId}_上车车站`],
      name: form[`E_${entityId}_乘车人姓名`],
      getOff: form[`E_${entityId}_下车车站`],
      status
    }
  }
}

function isObject(value) {
  return value !== null && typeof value === 'object';
}

function formatInvoiceDetails(details = []) {
  return details
    .filter(line => isObject(line))
    .map(line => {
      const { entityId, form, ...others } = line
      return {
        name: form[`E_${entityId}_name`],
        amount: form[`E_${entityId}_金额`],
        taxRate: form[`E_${entityId}_税率`],
        tax: form[`E_${entityId}_税额`],
        number: form[`E_${entityId}_数量`],
        model: form[`E_${entityId}_规格型号`],
        ...others
      }
    })
}

function formatData({ data, dateFormat }:any) {
  const { master, details } = data
  const { entityId, form, id, status } = master
  const value = form[`E_${entityId}_发票日期`]
  const value1 = value && (moment(value) ? moment(value).format(dateFormat) : moment().format(dateFormat))
  const basicFields = {
    id,
    buyer: {
      label: '购买方名称',
      value: {
        payer: form[`E_${entityId}_购买方名称`],
        payertaxno: form[`E_${entityId}_购买方纳税人识别号`],
        invdate: form[`E_${entityId}_invdate`]
      }
    },
    taxIdNum: {
      label: '购买方纳税人识别号',
      value: {
        payer: form[`E_${entityId}_购买方名称`],
        payertaxno: form[`E_${entityId}_购买方纳税人识别号`],
        invdate: form[`E_${entityId}_invdate`]
      }
    },
    invamt: form[`E_${entityId}_价税合计`],
    invtaxamt: form[`E_${entityId}_税额`],
    type: form[`E_${entityId}_发票类别`],
    fpdm: form[`E_${entityId}_发票代码`],
    fphm: form[`E_${entityId}_发票号码`],
    masterItems: [
      {
        label: '购买方地址电话',
        value: form[`E_${entityId}_购买方地址电话`]
      },
      {
        label: '购买方开户行及账号',
        value: form[`E_${entityId}_购买方开户行及账号`]
      },
      {
        type: 'seller',
        label: '销售方名称',
        // value: form[i18n.get(`E_{__k0}_销售方名称`, { __k0: entityId })],
        value: {
          payer: form[`E_${entityId}_销售方名称`],
          payertaxno: form[`E_${entityId}_销售方纳税人识别号`],
          invdate: form[`E_${entityId}_invdate`]
        }
      },
      {
        label: '发票代码',
        value: form[`E_${entityId}_发票代码`]
      },
      {
        label: '发票号码',
        value: form[`E_${entityId}_发票号码`]
      },
      {
        type: 'date',
        label: '开票日期',
        value: value1
      },
      {
        type: 'money',
        label: '价税合计',
        value: form[`E_${entityId}_价税合计`]
      },
      {
        type: 'money',
        label: '税额',
        value: form[`E_${entityId}_税额`]
      }
    ],
    source: form[`E_${entityId}_来源`],
    detailItems: formatInvoiceDetails(details),
    remark: form[`E_${entityId}_备注`],
    status
  }

  if (['system_非税收入类票据', 'system_机打发票'].includes(entityId) && !basicFields.source) {
    basicFields.source = form['E_system_发票主体_来源']
  }

  const invoiceType = form[`E_${entityId}_发票类别`]
  const vatInvoice = [
    'DIGITAL_NORMAL',
    'DIGITAL_SPECIAL',
    'PAPER_NORMAL',
    'PAPER_SPECIAL',
    'FULL_DIGITAl_PAPER',
    'FULL_DIGITAl_PAPER_NORMAL'
  ]
  if (vatInvoice.includes(invoiceType)) {
    const basicFieldsItems = basicFields.masterItems
    basicFieldsItems.splice(
      3,
      0,
      {
        type: 'sellerTaxNo',
        label: '销售方纳税人识别号',
        // value: form[i18n.get(`E_{__k0}_销售方纳税人识别号`, { __k0: entityId })],
        value: {
          payer: form[`E_${entityId}_销售方名称`],
          payertaxno: form[`E_${entityId}_销售方纳税人识别号`],
          invdate: form[`E_${entityId}_invdate`]
        }
      },
      {
        label: '销售方地址电话',
        value: form[`E_${entityId}_销售方地址电话`]
      },
      {
        label: '销售方开户行及账号',
        value: form[`E_${entityId}_销售方开户行及账号`]
      },
      {
        label: '校验码',
        value: form[`E_${entityId}_校验码`]
      }
    )
  }
  return basicFields
}

function isElectronicAirAndTrain(form:any) {
  return ['ELECTRONIC_AIRCRAFT_INVOICE', 'ELECTRONIC_TRAIN_INVOICE'].includes(form?.E_system_发票主体_发票类别)
}

function isElectronicTitle(form:any) {
  if (form?.E_system_发票主体_发票类别 === 'ELECTRONIC_AIRCRAFT_INVOICE') {
    return `${form?.E_system_发票主体_出发站} - ${form?.E_system_发票主体_到达站}`
  } else if (form?.E_system_发票主体_发票类别 === 'ELECTRONIC_TRAIN_INVOICE') {
    return `${form?.E_system_发票主体_上车车站} - ${form?.E_system_发票主体_下车车站}`
  }
  return ''
}

// 销项票展示购买方信息，非销项票展示销售方信息
function getTitleByInvoiceMark(invoiceForm:any, invoiceInfo:any) {
  // 电子航电火车票
  if (isElectronicAirAndTrain(invoiceForm)) {
    return isElectronicTitle(invoiceForm)
  } else if (invoiceForm?.['E_system_发票主体_进销项标识'] !== 'OUTPUT_INVOICE_RECEIPT') {
    const { masterItems } = invoiceInfo
    const seller = masterItems.find((line:any) => line.type === 'seller')
    return seller ? seller.value?.payer : masterItems[0].value
  }
  return invoiceInfo.buyer?.value?.payer
}

function formatInvoiceData({ data, type, dateFormat = 'YYYY.MM.DD', }: {
  data: any,
  dateFormat?: string,
  type?: string,
}) {
  const finalType = type || (data?.data ? 'oldData' : '');
  switch (finalType) {
    case 'oldData': {
      return { invoiceInfo: formatOldData({ arg: data }), originalData: data, isOld: true }
    }
    case 'train': {
      return { invoiceInfo: formatInvoiceTrain({ data }), originalData: data, isOld: false }
    }
    default: {
      return { invoiceInfo: formatData({ data, dateFormat }), originalData: data, isOld: false }
    }
  }
}

function TupleInvoiceType() {
  return [
    {
      label: '电子发票文件',
      value: 'UPLOAD'
    },
    {
      label: '手工录入',
      value: 'QUERY'
    },
    {
      label: '扫一扫录入',
      value: 'SCAN'
    },
    {
      label: '智能识票',
      value: 'OCR'
    },
    {
      label: '微信卡包导入',
      value: 'WECHAT_CARD'
    },
    {
      label: '支付宝卡包导入',
      value: 'ALIPAY_CARD'
    },
    {
      label: '爱发票导入',
      value: 'AIFAPIAO'
    },
    {
      label: '票池选择',
      value: 'OUTPUT_OPEN_API'
    },
    {
      label: '海外票据识别',
      value: 'OVERSEAS_INVOICE'
    }
  ]
}

// 检查是否有pdf文件
const fnCheckInvoicePdf = (invoiceInfo, invoiceValue, isFullDigital) => {
  const source = invoiceInfo && invoiceInfo.source
  const aliPayPDF = get(invoiceValue, 'master.form.E_system_发票主体_attachmentType', '')
  const ocrPDF = get(invoiceValue, 'master.form.E_system_发票主体_图片', '') || ''
  const pdf = ocrPDF.toLowerCase().endsWith('.pdf') || ocrPDF.toLowerCase().endsWith('.ofd')

  let hasPdf =
    source === 'UPLOAD' ||
    source === 'WECHAT_CARD' ||
    (source === 'ALIPAY_CARD' && aliPayPDF === 'PDF') ||
    (source === 'OCR' && pdf) ||
    (['AIFAPIAO', 'QXY'].includes(source) && pdf) ||
    (isFullDigital && pdf)
  if (
    source === 'OUTPUT_OPEN_API' &&
    invoiceValue?.master?.entityId === 'system_发票主体' &&
    invoiceValue?.master?.form?.['E_system_发票主体_原件地址']?.length > 0
  ) {
    hasPdf = true
  }
  return hasPdf
}

function invoiceMetaile(master:any) {
  const ifNormOpen = get(master, 'form.E_system_发票主体_ifNormOpen', false);
  if (!ifNormOpen || ((master === null || master === undefined ? undefined : master.entityId) !== 'system_发票主体' && (master === null || master === undefined ? undefined : master.entityId) !== 'system_机打发票')) {
    return { metaileText: '', shoMetailAction: false };
  }
  const hasMetaileFile = get(master, "form.E_system_\u53D1\u7968\u4E3B\u4F53_\u662F\u5426\u6709\u53D1\u7968\u539F\u4EF6", undefined);
  if (hasMetaileFile === undefined) {
    return { metaileText: '', shoMetailAction: false };
  }
  return {
    hasMetaileFile,
    metaileText: hasMetaileFile ? '有发票原文件' : '无发票原文件',
  };
}

const AddInvoiceTypeTextMap:Record<string,string> = {
  DIGITAL_NORMAL: '增值税电子普通发票',
  PAPER_NORMAL: '增值税普通发票',
  PAPER_SPECIAL: '增值税专用发票',
  FULL_DIGITAl_PAPER: '数电纸质发票（增值税专用发票）',
  FULL_DIGITAl_PAPER_NORMAL: '数电纸质发票（增值税普通发票）',
  PAPER_CAR: '机动车销售统一发票',
  PAPER_ROLL: '增值税普通发票（卷式）',
  PAPER_FEE: '通行费发票',
  FULL_DIGITAl_SPECIAL: '电子发票（增值税专用发票）',
  FULL_DIGITAl_NORMAL: '电子发票（普通发票）',
  BLOCK_CHAIN: '区块链电子发票',
  SECOND_CAR: '二手车销售统一发票',
  DIGITAL_SPECIAL: '增值税电子专用发票',
  ELECTRONIC_AIRCRAFT_INVOICE: '电子发票（航空运输电子客票行程单）',
  ELECTRONIC_TRAIN_INVOICE: '电子发票（铁路电子客票）'
}

// 增值税发票
export const AddInvoice = (props:any) => {
  const { invoiceInfo }: any = formatInvoiceData({ data: props, dateFormat: 'YYYY-MM-DD' })
  const { masterItems, type } = invoiceInfo
  const date = masterItems?.filter((i:any) => i.type === 'date')[0].value
  const { disable } = props.disableInfo ?? {}
  const isCheckerInvoice = get(props?.master?.form, 'E_system_发票主体_验真')
  const status = get(props?.master?.form, 'E_system_发票主体_发票状态')
  const source = get(props, 'master.form.E_system_发票主体_来源')
  const sourceLabel = TupleInvoiceType().find(el => el.value === source)?.label
  // 已验真状态下才判断红冲、作废
  const invoiceStatusStr = (invoiceForm:any) => {
    const statusKey = invoiceForm.E_system_发票主体_发票状态
    const statusMap:Record<string,string> = {
      NORMAL_BLUE: '已验真',
      RED_REVERSAL: '已红冲',
      INVOICE_NULLIFY: '已作废'
    }
    return statusMap[statusKey] ?? '已验真'
  }
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)

  return {
    title: getTitleByInvoiceMark(props.master.form, invoiceInfo),
    date,
    disable,
    sourceAmount: get(props, 'master.form.E_system_发票主体_价税合计'),
    isCheckerInvoice: isCheckerInvoice && status !== 'INVOICE_NULLIFY',
    checkerInvoiceText: isCheckerInvoice && status !== 'INVOICE_NULLIFY' ? invoiceStatusStr(props.master?.form) : '未验真',
    sourceLabel,
    amountLabel: '价税合计',
    metaileText,
    hasMetaileFile,
    typeText: AddInvoiceTypeTextMap[type] ?? '增值税发票'
  }
}

// 非税收入类票据
export const NontaxInvoice = (props:any) => {
  const { invoiceInfo } = formatInvoiceData({ data: props, dateFormat: 'YYYY-MM-DD' })

  const {
    E_system_非税收入类票据_开票日期,
    E_system_非税收入类票据_金额合计,
    E_system_非税收入类票据_发票种类,
    E_system_非税收入类票据_收款单位,
    E_system_非税收入类票据_发票类别,
    E_system_发票主体_来源,
  } = props.master.form

  const title = E_system_非税收入类票据_发票种类 || E_system_非税收入类票据_收款单位
  const date = moment(E_system_非税收入类票据_开票日期).format('YYYY-MM-DD')
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)
  const { type } = (invoiceInfo || {}) as any
  const isFullDigital = ['FULL_DIGITAl_SPECIAL', 'FULL_DIGITAl_NORMAL'].includes(type) // 全电票
  const hasPdf = fnCheckInvoicePdf(invoiceInfo, props, isFullDigital)

  return {
    title,
    date,
    disable,
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_非税收入类票据_金额合计,
    typeText: E_system_非税收入类票据_发票类别,
    typeTextColor: 'pur',
    hasPdf
  }
}

// 医疗发票
export const MedicalInvoice = (props:any) => {
  const { master } = props
  const { E_system_医疗发票_开票日期, E_system_医疗发票_金额合计, E_system_医疗发票_发票种类, E_system_发票主体_来源 } = master.form
  const title = E_system_医疗发票_发票种类
  const date = moment(E_system_医疗发票_开票日期).format('YYYY-MM-DD')
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)
  return {
    title,
    date,
    disable,
    typeText: '医疗发票',
    typeTextColor: 'success',
    sourceLabel,
    amountLabel: '总金额',
    metaileText,
    hasMetaileFile,
    sourceAmount: E_system_医疗发票_金额合计,
  }
}

// 出租车票
export const TaxiInvoice = (props:any) => {
  const { master } = props
  const {
    E_system_出租车票_发票所在地,
    E_system_出租车票_上车时间,
    E_system_出租车票_下车时间,
    E_system_出租车票_里程,
    E_system_出租车票_金额,
    E_system_发票主体_来源
  } = master.form
  const taxi_date = `${moment(E_system_出租车票_上车时间).format('YYYY-MM-DD HH:mm')}-${moment(
    E_system_出租车票_下车时间
  ).format('HH:mm')}`
  const title = E_system_出租车票_发票所在地
    ? `出租车发票 (${E_system_出租车票_发票所在地})`
    : ''
  const km = E_system_出租车票_里程 ? `${E_system_出租车票_里程}km` : ''
  const money = E_system_出租车票_金额 ?? ''
  const date = `${taxi_date} ${km}`
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)
  return {
    title,
    date,
    disable,
    typeText: '出租车票',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: money,
  }
}


// 过路费票
export const TollInvoice = (props:any) => {
  const { master } = props
  const {
    E_system_过路费发票_时间,
    E_system_过路费发票_入口,
    E_system_过路费发票_出口,
    E_system_过路费发票_金额,
    E_system_发票主体_来源
  } = master.form
  const _start = E_system_过路费发票_入口 ?? ''
  const _end = E_system_过路费发票_出口 ?? ''
  const title = `${_start} -- ${_end}`
  const date = moment(E_system_过路费发票_时间).format('YYYY-MM-DD HH:mm')
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)

  return {
    title,
    date,
    disable,
    typeText: '过路费票',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_过路费发票_金额,
  }
}

// 定额发票
export const QuotaInvoice = (props:any) => {
  const { master } = props
  const { E_system_定额发票_金额, E_system_发票主体_来源 } = master.form
  const title = '定额发票'
  const date = ''
  const money = E_system_定额发票_金额 ?? ''
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)
  return {
    title,
    date,
    disable,
    typeText: '定额发票',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: money,
  }
}

// 火车票
export const TrainInvoice = (props:any) => {
  const { master } = props
  const {
    E_system_火车票_乘车时间,
    E_system_火车票_车次,
    E_system_火车票_乘车人姓名,
    E_system_火车票_上车车站,
    E_system_火车票_下车车站,
    E_system_火车票_金额,
    E_system_发票主体_来源
  } = master.form
  const train_date = moment(E_system_火车票_乘车时间).format('YYYY-MM-DD HH:mm')
  const _start = E_system_火车票_上车车站 ?? ''
  const _end = E_system_火车票_下车车站 ?? ''
  const title = `${_start} -- ${_end}`
  const date = `${train_date} ${E_system_火车票_车次 ?? ''} ${E_system_火车票_乘车人姓名}`

  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)

  return {
    title,
    date,
    disable,
    typeText: '铁路客票',
    typeTextColor: 'info',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_火车票_金额,
  }
}

// 航空运输电子客票行程单
export const PlaneInvoice = (props:any) => {
  const { master } = props
  const {
    E_system_航空运输电子客票行程单_乘机时间,
    E_system_航空运输电子客票行程单_航班号,
    E_system_航空运输电子客票行程单_乘机人姓名,
    E_system_航空运输电子客票行程单_座位等级,
    E_system_航空运输电子客票行程单_出发站,
    E_system_航空运输电子客票行程单_到达站,
    E_system_航空运输电子客票行程单_金额,
    E_system_发票主体_来源
  } = master.form
  const plane_date = moment(E_system_航空运输电子客票行程单_乘机时间).format('YYYY-MM-DD HH:mm')
  const _start = E_system_航空运输电子客票行程单_出发站 ?? ''
  const _end = E_system_航空运输电子客票行程单_到达站 ?? ''
  const title = `${_start} -- ${_end}`
  const _code = E_system_航空运输电子客票行程单_航班号 ?? ''
  const _name = E_system_航空运输电子客票行程单_乘机人姓名 ?? ''
  const _grade = E_system_航空运输电子客票行程单_座位等级 ?? ''
  const date = `${plane_date} ${_code} ${_name} ${_grade}`

  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)

  return {
    title,
    date,
    disable,
    typeText: '机票行程单',
    typeTextColor: 'info',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_航空运输电子客票行程单_金额,
  }
}

// 客运汽车发票
export const BusInvoice = (props:any) => {
  const { master } = props
  const {
    E_system_客运汽车发票_时间,
    E_system_客运汽车发票_出发车站,
    E_system_客运汽车发票_达到车站,
    E_system_客运汽车发票_金额,
    E_system_客运汽车发票_姓名,
    E_system_发票主体_来源
  } = master.form
  const _start = E_system_客运汽车发票_出发车站 ?? ''
  const _end = E_system_客运汽车发票_达到车站 ?? ''
  const title = `${_start} -- ${_end}`
  const bus_name = E_system_客运汽车发票_姓名 ?? ''
  const date = `${moment(E_system_客运汽车发票_时间).format('YYYY-MM-DD HH:mm')} ${bus_name}`
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)
  return {
    title,
    date,
    disable,
    typeText: '客运汽车票',
    typeTextColor: 'info',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_客运汽车发票_金额,
  }
}

// 海外发票
export const OverseasInvoice = (props:any) => {
  const { master } = props
  const { E_system_海外发票_日期, E_system_海外发票_金额, E_system_海外发票_title, E_system_发票主体_图片, E_system_发票主体_来源 } = master.form
  const title = E_system_海外发票_title || '海外票据'
  const date = moment(E_system_海外发票_日期).format('YYYY-MM-DD')
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props?.master)
  const hasPdf = E_system_发票主体_图片 && E_system_发票主体_图片.toLowerCase().endsWith('.pdf')

  return {
    title,
    date,
    disable,
    typeText: '海外票据',
    typeTextColor: 'pur',
    sourceLabel,
    amountLabel: '总金额',
    metaileText,
    hasMetaileFile,
    sourceAmount: E_system_海外发票_金额,
    hasPdf
  }
}

// 其他票据
export const OtherInvoice = (props:any) => {
  const { master } = props
  const { E_system_其他_日期, E_system_其他_金额, E_system_发票主体_来源 } = master.form
  const date = moment(E_system_其他_日期).format('YYYY-MM-DD')
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props.master)
  return {
    title: '其他票据',
    date,
    disable,
    typeText: '其他票据',
    typeTextColor: 'default',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_其他_金额,
  }
}

// 消费小票
export const ShoppingInvoice = (props:any) => {
  const { master } = props
  const { E_system_消费小票_店名, E_system_消费小票_时间, E_system_消费小票_金额, E_system_发票主体_来源 } = master.form
  const title = E_system_消费小票_店名 || '无法识别店名'
  const date = `${moment(E_system_消费小票_时间).format('YYYY-MM-DD HH:mm')}`
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props.master)
  return {
    title,
    date,
    disable,
    typeText: '消费小票',
    typeTextColor: 'info',
    sourceLabel,
    amountLabel: '总金额',
    metaileText,
    hasMetaileFile,
    sourceAmount: E_system_消费小票_金额,
  }
}

// 机打发票
export const MachineInvoice = (props:any) => {
  const { master } = props
  const {
    E_system_机打发票_时间,
    E_system_机打发票_金额,
    E_system_机打发票_销售方名称,
    E_system_机打发票_发票种类,
    E_system_发票主体_来源
  } = master.form
  const title = E_system_机打发票_销售方名称
  const { invoiceInfo } = formatInvoiceData({ data: props, dateFormat: 'YYYY-MM-DD' })

  const date = moment(E_system_机打发票_时间).format('YYYY-MM-DD HH:mm')
  const { disable } = props.disableInfo ?? {}
  const sourceLabel = TupleInvoiceType().find(el => el.value === E_system_发票主体_来源)?.label
  const { metaileText, hasMetaileFile } = invoiceMetaile(props.master)
  const hasPdf = fnCheckInvoicePdf(invoiceInfo, props, false)

  return {
    title,
    date,
    disable,
    typeText: E_system_机打发票_发票种类 || '机打发票',
    typeTextColor: 'success',
    sourceLabel,
    amountLabel: '总金额',
    metaileText, hasMetaileFile,
    sourceAmount: E_system_机打发票_金额,
    hasPdf
  }
}

export const invoiceMap:any = {
  system_发票主体: AddInvoice,
  system_非税收入类票据: NontaxInvoice,
  system_医疗发票: MedicalInvoice,
  system_出租车票: TaxiInvoice,
  system_过路费发票: TollInvoice,
  system_定额发票: QuotaInvoice,
  system_火车票: TrainInvoice,
  system_航空运输电子客票行程单: PlaneInvoice,
  system_客运汽车发票: BusInvoice,
  system_海外发票: OverseasInvoice,
  system_其他: OtherInvoice,
  system_消费小票: ShoppingInvoice,
  system_机打发票: MachineInvoice,
}